import { InstructionCounts, InstructionType } from 'app/src/engine/Instruction';
import { InstructionsArchiveContextProvider } from 'app/src/game/InstructionsArchiveContext';
import * as React from 'react';

type Props = {
	children: React.ReactNode;
	initialInstructionCounts: InstructionCounts;
};

export default function InstructionsArchiveController({
	children,
	initialInstructionCounts,
}: Props): React.ReactElement | null {
	const [instructionCounts, setInstructionCounts] = React.useState<InstructionCounts>(
		initialInstructionCounts,
	);

	const loadInstructionCounts = (newCounts: InstructionCounts): void => {
		setInstructionCounts(newCounts);
	};

	const setInstructionCount = (type: InstructionType, count: number): void => {
		setInstructionCounts((nextInstructionCounts) => {
			const newInstructionCounts = new Map(nextInstructionCounts);
			newInstructionCounts.set(type, count);
			return newInstructionCounts;
		});
	};

	const clearInstructionCounts = (): void => {
		setInstructionCounts(new Map());
	};

	return (
		<InstructionsArchiveContextProvider
			value={{
				instructionCounts,
				loadInstructionCounts,
				setInstructionCount,
				clearInstructionCounts,
			}}
		>
			{children}
		</InstructionsArchiveContextProvider>
	);
}
